import Immutable from 'seamless-immutable';

export const Types = {
  LOGIN_REQUEST: 'login/LOGIN_REQUEST',
  LOGIN_CANCELLED: 'login/LOGIN_CANCELLED',
  LOGIN_SUCCESS: 'login/LOGIN_SUCCESS',
  LOGIN_FAILED: 'login/LOGIN_FAILED',
};

const initialState = Immutable({
  loading: false,
  error: false,
  data: [],
});

export const Creators = {
  postLoginRequest: (userLoginDetailsEzq) => ({
    type: Types.LOGIN_REQUEST,
    payload: userLoginDetailsEzq,
  }),

  getLoginSuccess: (data) => (
    {
    type: Types.LOGIN_SUCCESS,
    payload: {data},
  }
  ),
  getLoginFailure: () => ({
    type: Types.LOGIN_FAILED,
  }),
  loginCancelled: () => ({
    type: Types.LOGIN_CANCELLED,
  })
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case Types.LOGIN_REQUEST:
      return {
        ...state,
        data: action.payload.data,
        loading: true,
      };
    case Types.LOGIN_SUCCESS:
      return {
        data: action.payload.data,
        loading: false,
      };     
    case Types.LOGIN_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case Types.LOGIN_CANCELLED:
      return {
        ...state,
        loading: false,
        error: true,
      };
    default:
      return state;
  }
};

export default login;